
import { Component, Input } from '@angular/core';
import { TableEntryAdmin } from '@reflact/ipkv-types';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-ki-result-table',
  imports: [TableModule],
  templateUrl: './ki-result-table.html',
  styleUrl: './ki-result-table.scss',
})
export class KiResultTable {
  @Input() table: TableEntryAdmin[][] = [];
  @Input() userAnswers: string[][] = [];
  @Input() kiTable: { comment: string; score: number }[] = [];
  @Input() kiReasoning: string = '';
}
